import React from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const FormInput = ({
  label,
  name,
  type = "text",
  value = '',
  onChange,
  onFocus,
  onBlur,
  placeholder,
  required = false,
  disabled = false,
  icon: Icon,
  error,
  helperText,
  borderStyle = "gray", // "gray" or "black"
  className = "",
  inputClassName = "",
  maxLength,
  options = [], // for select dropdown
  openDropdown,
  ...props
}) => {
  const isSelect = type === "select";
  const isDate = type === "date";
  
  const getBorderClass = () => {
    if (borderStyle === "black") {
      return "border-b-4 border-black w-full";
    }
    return "border-b-[2px] border-solid border-[#ccc]";
  };

  const getInputContainerClass = () => {
    if (isSelect) {
      return "flex items-center gap-2 pb-2 relative border-b-[2px] border-solid box-border h-[40px] border-[#ccc]";
    }
    if (borderStyle === "gray") {
      return "flex items-center gap-2 pb-2 border-b-[2px] border-solid box-border h-[40px] border-[#ccc]";
    }
    return "flex items-center gap-3 pb-3";
  };

  const getInputClass = () => {
    const baseClass = "flex-1 inline-block outline-none bg-transparent text-gray-700 placeholder-gray-400 text-base font-normal";
    
    if (isSelect) {
      return `${baseClass} px-2 py-3 rounded-lg bg-gray-100  border-solid border-[#ccc] appearance-none cursor-pointer pr-10`;
    }
    
    if (disabled) {
      return `${baseClass} text-gray-600`;
    }
    
    return `${baseClass} ${inputClassName}`;
  };

  return (
    <div className={className}>
      <label className="block text-sm font-semibold text-gray-800 mb-2">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      
      <div>
        <div className={getInputContainerClass()}>
          {Icon && <Icon size={20} className="text-blue-500" />}
          
          {isSelect ? (
            <>
              <select
                name={name}
                value={value}
                onChange={onChange}
                onFocus={onFocus}
                onBlur={onBlur}
                className={getInputClass()}
                {...props}
              >
                <option value="">Select {label.toLowerCase()}</option>
                {options.map((option) => (
                  <option key={option.value || option} value={option.value || option}>
                    {option.label || option}
                  </option>
                ))}
              </select>
              <div className="absolute right-3 pointer-events-none text-gray-400">
                {openDropdown ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
              </div>
            </>
          ) : (
            <input
              type={type}
              name={name}
              value={value}
              onChange={onChange}
              onFocus={onFocus}
              onBlur={onBlur}
              placeholder={placeholder}
              disabled={disabled}
              maxLength={maxLength}
              className={getInputClass()}
              {...props}
            />
          )}
        </div>
        
        {borderStyle === "black" && (
          <div className={getBorderClass()}></div>
        )}
      </div>
      
      {error && (
        <p className="text-red-500 text-xs mt-2">
          {error}
        </p>
      )}
      
      {helperText && !error && (
        <p className="text-xs text-gray-400 mt-2">
          {helperText}
        </p>
      )}
    </div>
  );
};

export default FormInput;